import apiClient from '../request/http-common';

class CountryService {
  // Get all countries
  async getCountries() {
    const response = await apiClient.get('/api/countries');
    return response.data;
  }

  // Get all currencies
  async getCurrencies() {
    const response = await apiClient.get('/api/currencies');
    return response.data;
  }

  // Get supported cryptocurrencies
  async getSupportedCoins() {
    const response = await apiClient.get('/api/supported-coins');
    return response.data;
  }
}

export default new CountryService();
